const SAMPLE_STATISTICS_DATA_FETCHING = 'SAMPLE_STATISTICS_DATA_FETCHING';
const SAMPLE_STATISTICS_DATA_FETCHED = 'SAMPLE_STATISTICS_DATA_FETCHED';
const SAMPLE_STATISTICS_DATA_FETCHING_FAILED = 'SAMPLE_STATISTICS_DATA_FETCHING_FAILED';
const SAMPLE_STAT_DATA_STATE_ADD = 'SAMPLE_STAT_DATA_STATE_ADD';
const SAMPLE_STAT_DATA_STATE_REMOVE = 'SAMPLE_STAT_DATA_STATE_REMOVE';
const SAMPLE_STTS_GRPAH_COLOR_SCHEME = {
  "QC":"#73B9F2",
  "CAL":"#23619E",
  "Serum":"#FEDF45",
  "Urine":"#AEC833",
  "Whole Blood":"#811167",
  "Plasma":"#DF4644",
  "Amniotic":"#EA1C2C",
  "CSF":"#474C55",
  "Cervical":"#2F81D3",
  "Other":"#C5C5C5",
  "Saliva":"#A73533",
  "Swab":"#BFA734",
  "Synovial":"#3E3EFF",
  "Timed Urine":"#7C858C",
  "Urethral":"#00A9E0",
  "Pediatric":"#B2B2B2",
  "Hemolysis":"#DAD9D6",
  "Citrated Plasma":"#839626",
  "Unspecified":"#9B9EA0"
};

const DATE_RANGE_EXCEEDS_14_DAY_LIMIT='Selected date range is beyond 14 days interval, Please select date range within 14 days.'

const DATE_SELECTED_INVALID='Start date cannot be greater than End date'
export {
    SAMPLE_STATISTICS_DATA_FETCHING,
    SAMPLE_STATISTICS_DATA_FETCHED,
    SAMPLE_STATISTICS_DATA_FETCHING_FAILED,
    SAMPLE_STTS_GRPAH_COLOR_SCHEME,
    SAMPLE_STAT_DATA_STATE_ADD,
    SAMPLE_STAT_DATA_STATE_REMOVE,
    DATE_RANGE_EXCEEDS_14_DAY_LIMIT,
    DATE_SELECTED_INVALID
}